import { ISortSelectOption } from 'src/components/filter/types/filter.types'
import { EAccountSubscriptionPlans } from 'src/types'

export const useSubscriptionsSelectionOptions = () => {
  const items: ISortSelectOption[] = [
    { value: 'all', label: 'all' },
    { value: EAccountSubscriptionPlans.free, label: 'Free' },
    { value: EAccountSubscriptionPlans.plus, label: 'Plus' },
    { value: EAccountSubscriptionPlans.premium, label: 'Premium' },
    { value: EAccountSubscriptionPlans.enterprise, label: 'Enterprise' },
  ]

  return {
    selectName: 'subscription-filter-title.v',
    queryParamName: 'subscription',
    items,
  }
}
